var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3726 5.8H20.1C20.3387 5.8 20.5676 5.89482 20.7364 6.0636C20.9052 6.23239 21 6.46131 21 6.7V19.3C21 19.5387 20.9052 19.7676 20.7364 19.9364C20.5676 20.1052 20.3387 20.2 20.1 20.2H3.9C3.66131 20.2 3.43239 20.1052 3.2636 19.9364C3.09482 19.7676 3 19.5387 3 19.3V4.9C3 4.66131 3.09482 4.43239 3.2636 4.2636C3.43239 4.09482 3.66131 4 3.9 4H10.5726L12.3726 5.8ZM4.8 7.6V18.4H19.2V7.6H4.8Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/icon-folder.4ca756e4f98a84a3506c7262e2100431.svg";
export { ForwardRef as ReactComponent };